import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { normalizeUiLang } from './localePreference';

export type PlanI18nSlug = 'free' | 'silver' | 'gold' | 'platinum';

/** Map API plan name to i18n key prefix (home_plan_{slug}_*). */
export function getPlanI18nSlug(planName: string): PlanI18nSlug | null {
  const n = planName.toLowerCase();
  if (n.includes('platinum')) return 'platinum';
  if (n.includes('gold')) return 'gold';
  if (n.includes('silver')) return 'silver';
  if (n.includes('standard')) return 'silver';
  if (n.includes('premium')) return 'gold';
  if (n.includes('free')) return 'free';
  return null;
}

/** Prefer CMS copy in English; use i18n for Kiswahili and French. */
export function useHomepageText() {
  const { t, i18n } = useTranslation();
  const lang = normalizeUiLang(i18n.resolvedLanguage || i18n.language);
  const isEn = lang === 'en';

  const txt = useCallback(
    (key: string, cms?: string | null) => {
      const cmsTrim = typeof cms === 'string' ? cms.trim() : '';
      if (isEn && cmsTrim) return cmsTrim;
      return t(key);
    },
    [isEn, t],
  );

  const txtList = useCallback(
    (key: string, cmsList?: string[] | null): string[] => {
      if (isEn && cmsList && cmsList.length > 0) return cmsList;
      const fromI18n = t(key, { returnObjects: true });
      if (Array.isArray(fromI18n)) return fromI18n as string[];
      return cmsList ?? [];
    },
    [isEn, t],
  );

  return { t, txt, txtList, lang, isEn };
}
